import React, { useState, type FC } from 'react'

import { useRecoilValue } from 'recoil'

import {
  Flex,
  FlexItem,
  SidePanel,
  SidePanelHeader,
} from 'mailup-web-components'

import BoxEditContacts from 'Pages/RecipientsList/components/contacts/BoxEditContacts'
import PanelEditContactsFooter from 'Pages/RecipientsList/components/contacts/PanelEditContactsFooter'
import PanelEditContactsHeader from 'Pages/RecipientsList/components/contacts/PanelEditContactsHeader'

import { panelEditContactsState } from 'Pages/RecipientsList/recoil/state/editContacts'

const PanelEditContacts: FC = () => {
  const [y, setY] = useState(0)

  const { show } = useRecoilValue(panelEditContactsState)

  const handleClickOutside = (): void => {}

  return (
    <SidePanel
      show={show}
      onClickOutside={handleClickOutside}
      width="740px"
      onContentScrollY={setY}
    >
      <SidePanelHeader padding="16px 32px 0 32px" showBorder={y > 0}>
        <PanelEditContactsHeader />
      </SidePanelHeader>

      <Flex flexDirection="column" height="100%">
        <Flex flexDirection="column" gap="24px" padding="24px 32px">
          <BoxEditContacts />
        </Flex>

        <FlexItem flexGrow="1" />

        <PanelEditContactsFooter />
      </Flex>
    </SidePanel>
  )
}

export default PanelEditContacts
